import './styles.css';
import React from 'react';

import Modal from './Modal';
import Component from './Component';

const ContactForm = props => (props.modal ? <Modal onModalToggle={props.onModalToggle} /> : <Component dropdown />);

export default ContactForm;
